import React from 'react';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import {Box} from "@mui/material";
import {useLanguage} from "../../LanguageContext";
import dayjs from "dayjs";
import {useNavigation} from "../../NavigationProvider";

const Tour = ({tour}) => {
    const {t} = useLanguage();
    const {navigateFromBackButton} = useNavigation();

    const outdated = dayjs(t(tour.date)).isBefore(dayjs())
    return (
        <Card
            onClick={() => {
                if (tour.active) {
                    navigateFromBackButton(tour.page);
                }
            }}
            sx={{
                cursor: tour.active ? "pointer" : "default",
                maxHeight: '60vh',
                width: '100%',
                aspectRatio: '1 / 1.4',
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-end",
                backgroundImage: `url(${tour.image})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                color: "#fff",
                borderRadius: 0,
                overflow: "hidden",
                filter: !tour.active || outdated ? "grayscale(100%)" : "none",
                opacity: !tour.active || dayjs(tour.dateText).isBefore(dayjs()) ? 0.6 : 1,
                position: "relative",
            }}
        >
            {tour.label && (
                <Box
                    sx={{
                        position: "absolute",
                        top: 10,
                        right: 10,
                        background:
                            tour.label === "VIP" ? "gold" :
                                tour.label === "Premium" ? "silver" :
                                    tour.label === "Exclusive" ? "purple" :
                                        "blue", // Default color for other labels
                        color: "#fff",
                        padding: "6px 12px",
                        borderRadius: "12px",
                        fontWeight: "bold",
                        fontSize: "0.9rem",
                        textTransform: "uppercase",
                    }}
                >
                    {t(tour.label)}
                </Box>
            )}

            {!tour.active && (
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%) rotate(-45deg)",
                        // background: "rgba(255, 165, 0, 0.8)", // Semi-transparent orange
                        padding: "10px 20px",
                        borderRadius: "8px",
                        color: "#fff",
                        fontSize: "3.5rem",
                        fontWeight: "bold",
                        textTransform: "uppercase",
                    }}
                >
                    {t('label_coming_soon')}
                </Box>
            )}
            {/*{tour.active && outdated && (*/}
            {/*    <Box*/}
            {/*        sx={{*/}
            {/*            position: "absolute",*/}
            {/*            top: "50%",*/}
            {/*            left: "50%",*/}
            {/*            transform: "translate(-50%, -50%) rotate(-45deg)",*/}
            {/*            // background: "rgba(255, 165, 0, 0.8)", // Semi-transparent orange*/}
            {/*            padding: "10px 20px",*/}
            {/*            borderRadius: "8px",*/}
            {/*            color: "#fff",*/}
            {/*            fontSize: "2.2rem",*/}
            {/*            fontWeight: "bold",*/}
            {/*            textTransform: "uppercase",*/}
            {/*        }}*/}
            {/*    >*/}
            {/*        {t('label_experience_end_title')}*/}
            {/*    </Box>*/}
            {/*)}*/}
            <Box sx={{
                background: "rgba(0, 0, 0, 0.4)"
            }}>
                <Box sx={{padding: '20px'}}>
                    <Typography
                        sx={{
                            color: 'white',
                            fontSize: '26px',
                            fontFamily: 'Jost-Regular',
                            pb: '8px',
                        }}>
                        {t(tour.country)}
                    </Typography>
                    <Typography sx={{
                        color: 'white',
                        fontSize: '18px',
                        fontFamily: 'Jost-Regular',
                    }}>
                        {t(tour.dateText)}
                    </Typography>
                    <Typography sx={{
                        color: 'white',
                        fontSize: '18px',
                        fontFamily: 'Jost-Regular',
                    }}>
                        {t(tour.description)}
                    </Typography>
                    {/*<Typography variant="subtitle1">*/}
                    {/*    {t(tour.price)}*/}
                    {/*</Typography>*/}
                </Box>
            </Box>
        </Card>
    );
};


export default Tour;
